var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09277 0.000976562H37.8863L46.1524 8.26707V32.273C46.1524 35.5867 43.4661 38.273 40.1524 38.273H9.09277V0.000976562Z",
    fill: "url(#paint0_linear_26_503)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.9585,
    y: 40.0381,
    width: 2.75536,
    height: 44.6369,
    transform: "rotate(-90 4.9585 40.0381)",
    fill: "#9F77EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.9585,
    y: 42.7943,
    width: 1.65322,
    height: 44.6369,
    transform: "rotate(-90 4.9585 42.7943)",
    fill: "#9F77EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61172 45C5.69867 45 4.9585 44.2598 4.9585 43.3468L49.5954 43.3468C49.5954 44.2598 48.8552 45 47.9422 45L6.61172 45Z",
    fill: "#9F77EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1709,
    y: 20.3921,
    width: 2.20429,
    height: 9.91931,
    transform: "rotate(90 30.1709 20.3921)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0693,
    y: 15.4302,
    width: 2.20429,
    height: 8.81716,
    transform: "rotate(90 29.0693 15.4302)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.314,
    y: 30.3087,
    width: 2.20429,
    height: 6.0618,
    transform: "rotate(90 26.314 30.3087)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8862,
    y: 25.3503,
    width: 2.20429,
    height: 17.6343,
    transform: "rotate(90 37.8862 25.3503)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1523 8.26611H37.8863V2.38419e-05L42.2948 4.4086L46.1523 8.26611Z",
    fill: "#DECDFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 35.6302,
    width: 2.75536,
    height: 54.5562,
    transform: "rotate(-90 0 35.6302)",
    fill: "#9F77EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_503",
    x1: 27.6226,
    y1: 0.000976562,
    x2: 27.6226,
    y2: 38.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F77EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F77EB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.f97cecb01952e13161122870418489ba.svg";
export { ForwardRef as ReactComponent };